import { createContext } from 'react'

export const initialState = false

export const NotiContext = createContext(initialState)
